import type { LabStatus } from '@optimist/schemas'
import type { StatusBadgeVariant } from '@/components/status-badge'

export const labStatusVariants: Record<LabStatus, StatusBadgeVariant> = {
  not_started: 'outline',
  ordered: 'info',
  kit_shipped: 'info',
  kit_delivered: 'success',
  sample_in_transit: 'info',
  sample_delivered: 'success',
  sample_received: 'success',
  results_pending: 'info',
  results_approved: 'success',
  results_rejected: 'destructive',
  failed: 'destructive',
}
